import { observer } from 'mobx-react';
import * as PropTypes from 'prop-types';
import { Children } from 'react';
import * as React from 'react';
import { Component } from 'react';

export interface UIFormBindings {
    errorMessageBinding?;
    form?;
}

export interface UIBindings {
    form: UIFormBindings;
}

export interface UIProviderProps {
    bindings: UIBindings
}

@observer export class UIProvider extends Component<UIProviderProps, any> {

    static defaultProps = {
        bindings: {}
    };

    static childContextTypes = {
        uiProvider: PropTypes.object,
    };

    getChildContext() {
        const { bindings } = this.props;

        return {
            uiProvider: {
                bindings
            }
        }
    }

    render() {
        return Children.toArray(this.props.children);
    }

}
